function Instagram() {
	return (
	<div>Instagram


	</div>
	)
}

export default Instagram